export const ITEMS_PER_PAGE = 10;

export const ROUTE_LABELS: Record<string, string> = {
  dashboard: '대시보드',
  ships: '선박관리',
  voyages: '운항관리',
  maintenance: '정비관리',
  crew: '선원관리',
  alerts: '알림',
  notices: '공지사항',
  register: '등록',
  schedule: '일정',
  'work-order': '작업지시서',
  assignment: '배치관리',
};
